module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sk-563985765998ec7428e99bda01cbee7c.svg";